const emailInventory = [
  {
    id: 0,
    type: 'single',
    name: 'Rambuhtan',
    imgSrc: 'https://saturiwa.b-cdn.net/rambuhtan.jpg?quality=50&width=720',
    active: true,
    description: 'A banana is an elongated, edible fruit - botanically a berry - produced by several kinds of large herbaceous flowering plants in the genus Musa.',
    price: '$8 per lb',
    aspectRatio: 'none',
  },
  {
    id: 1,
    type: 'single',
    name: 'Apple',
    imgSrc: 'https://saturiwa.b-cdn.net/apple.jpg?quality=50&width=720',
    active: true,
    description: 'The apple is a red fruit',
    price: '$9.99 per lb',
    aspectRatio: 'none',
  },
  {
    id: 2,
    type: 'single',
    name: 'mango',
    imgSrc: 'https://saturiwa.b-cdn.net/mangos.jpg?quality=50&width=720',
    active: true,
    description: 'Mangos fresh from my backyard',
    price: '$24.99 per box',
    aspectRatio: 'none',
    
  },
  {
    id: 3,
    type: 'listing',
    listType: 'list', // or columns
    name: 'Fruits',
    showImages: false,
    description: 'Fresh from my backyard!',
    active: true,
    items: [ 0, 1, 2, ],
  },
  {
    id: 4,
    type: 'single',
    name: 'Cherokee Heirloom Tomatoes',
    imgSrc: 'https://saturiwa.b-cdn.net/cherokeetomatoes.jpg?quality=50&width=720',
    active: true,
    description: `"One day in 1990, a packet of tomato seeds arrived in LeHoullier's mail with a <a href='http://www.weebly.com/uploads/2/3/8/3/2383969/5162829_orig.jpg' style="font-weight: bold; color: inherit;" >handwritten note</a>. The sender was John Green of Sevierville, Tenn., who wrote that the seeds came from very good tomatoes he'd gotten from a woman who received them from her neighbors. The neighbors said that the varietal had been in their family for 100 years, and that the seeds were originally received from Cherokee Indians."`,
    price: '$46 per box',
    aspectRatio: 'none',
    
  },
  {
    id: 5,
    type: 'single',
    name: 'Grey Morels',
    imgSrc: 'https://saturiwa.b-cdn.net/greymorels.jpg?quality=50&width=720',
    active: true,
    description: 'This is it til next Spring!',
    price: '$29.50 per lb',
    aspectRatio: 'none',
    
  },
  {
    id: 6,
    type: 'single',
    name: 'Golden Chanterelles',
    imgSrc: 'https://saturiwa.b-cdn.net/goldenchant.jpg?quality=50&width=720',
    active: true,
    description: 'This is it til next Spring!',
    price: '$28.50 per lb',
    aspectRatio: 'none',
    
  }
]

const state = {
  windowWidth: 0,
  emailInventory: emailInventory,
  featuredInventory: [
    {
      title: 'Spices',
      img: require('@/assets/img/featured/spices.jpg'),
      imgSmall: require('@/assets/img/featured/spicesSmall.jpg'),
    },
    {
      title: 'Spice Blends',
      img: require('@/assets/img/featured/spiceblends.jpg'),
      imgSmall: require('@/assets/img/featured/spiceblendsSmall.jpg'),
    },
    {
      title: 'Nuts and Seeds',
      img: require('@/assets/img/featured/nuts.jpg'),
      imgSmall: require('@/assets/img/featured/nutsSmall.jpg'),
    },
    {
      title: 'Dried Fruits',
      img: require('@/assets/img/featured/driedfruits.jpg'),
      imgSmall: require('@/assets/img/featured/driedfruitsSmall.jpg'),
    },
    {
      title: 'Mushrooms',
      img: require('@/assets/img/featured/mushrooms.jpg'),
      imgSmall: require('@/assets/img/featured/mushroomsSmall.jpg'),
    },
    {
      title: 'Asian',
      img: require('@/assets/img/featured/asian.jpg'),
      imgSmall: require('@/assets/img/featured/asianSmall.jpg'),
    },
    {
      title: 'Fruit',
      img: require('@/assets/img/featured/fruits.jpg'),
      imgSmall: require('@/assets/img/featured/fruitsSmall.jpg'),
    },
    {
      title: 'Veggies',
      img: require('@/assets/img/featured/veggies.jpg'),
      imgSmall: require('@/assets/img/featured/veggiesSmall.jpg'),
    },
    {
      title: 'Caviar',
      img: require('@/assets/img/featured/caviar.jpg'),
      imgSmall: require('@/assets/img/featured/caviarSmall.jpg'),
    },
    {
      title: 'Meats',
      img: require('@/assets/img/featured/meats.jpg'),
      imgSmall: require('@/assets/img/featured/meatsSmall.jpg'),
    },
    {
      title: 'Other and Misc',
      img: require('@/assets/img/featured/other.jpg'),
      imgSmall: require('@/assets/img/featured/otherSmall.jpg'),
    },
  ],
  showedConstruction: false,
  mailPActive: false,
  mjmlHTML: '',
}

export default state
